import zhCnLocale from "element-ui/lib/locale/lang/zh-CN";
const cn = {
  message: {
    lan: "Cn",
    errorMessage: {
      ServerException: "服务器异常",
      ClientException: "客户端异常",
      NetworkException: "未知网络异常",
      CheckNetwork: "请检查网络",
      UnknownError: "未知错误",
      captchaError: "验证码错误！请重新输入"
    },
    index: "首页",
    course_learning: "课程学习及进度",
    course_learn: "课程学习",
    viewed_times: "浏览次数",
    course_catalog: "课程目录",
    learning_progress: "学习进度",
    view_exam_record: "查看模拟考试记录",
    learn_review: "学习回顾",
    continue_learning: "继续学习",
    to_learn: "去学习",
    take_the_mock_test: "参与模拟考试",
    replay: "重播",
    play: "播放",
    pause: "暂停",
    muteMe: "静音",
    sound: "声音",
    search_chapter_placeholder: "请输入标题",
    practice_test: "模拟考试",
    exam_record: "模拟考试记录",
    course_name: "课程名称",
    exam_score: "测验分数",
    operation_time: "操作时间",
    view: "查看",
    title_TRUE_OR_FALSE: "是非题",
    title_SINGLE_CHOICE: "单选题",
    title_SHORT_ANSWER: "简答题",
    title_MULTIPLE_CHOICE: "多选题",
    correct: "正确",
    wrong: "错误",
    correct_answer: "回答正确",
    wrong_answer: "回答错误",
    right_key: "正确答案",
    submit_test: "提交试卷",
    next_question: "下一题",
    back: "返回",
    exam_result: "考试结果",
    answers_situation: "答题情况",
    return_exam_record: "返回模拟考试记录",
    reTest: "重新考试",
    back_to_home: "返回主页",
    all: "全部",
    learning: "学习中",
    finished_learning: "已学完",
    submit: "提交",
    logout: "登出",
    course_list: "课程列表",
    prev_section: "上一节",
    next_section: "下一节",
    start_chapter_learn: "进入本章学习",
    return_prev_chapter: "返回上一章节",
    return_this_chapter: "返回本章",
    start_next_chapter: "进入下一章",
    to_test: "进入模拟考试",
    chapter_start: "本章开始",
    chapter_end: "本章结束",
    copyright: "澳门特别行政区政府劳工事务局版权所有",
    course_entry: "进入课程",
    start_test: "开始考试",
    test_tips: "课程进度不足80%，请耐心学习再参与考试",
    question_tips: "课程进度不足80%，请耐心学习再参与问卷",

    tips: "提示",
    confirm: "确认",
    question_already: "每份问卷只能填写一次",

    exam_excellent: "恭喜，你的模拟考试分数优秀",
    exam_pass: "加油，你的模拟考试分数合格",
    exam_fail: "请继续努力，你的模拟考试分数不理想",

    submit_success: "提交成功",
    submit_error: "提交失败",

    learning_content: "学习内容",

    priority_tips: "推荐按以下顺序学习课程",
    goto_course: "前往课程",
    current: "(当前)",
    no_question: "获取题目失败",
    public_questionnaires_Invalid: "问卷已失效或未生效！",

    web_title: "劳工事务局eLearning",
    question_public_title: "劳工事务局",
    online_services: "网上报名",
    write_tips: "请填写课后问卷，以便本局持续改善本网上学习课程，谢谢！",
    chapter: "第{0}章",
    section: "第{0}节",
    question_must_be_completed: "问卷需填写完才能提交",
    captcha_plh: "请输入验证码",
    noData: "暂无数据",
    question: "问卷调查",
    noVoice: "No voice",
    numberToCN: [
      "〇",
      "一",
      "二",
      "三",
      "四",
      "五",
      "六",
      "七",
      "八",
      "九",
      "十",
      "十一",
      "十二",
      "十三",
      "十四",
      "十五",
      "十六",
      "十七",
      "十八",
      "十九",
      "二十",
      "二十一",
      "二十二",
      "二十三",
      "二十四",
      "二十五",
      "二十六",
      "二十七",
      "二十八",
      "二十九",
      "三十",
      "三十一",
      "三十二",
      "三十三",
      "三十四",
      "三十五",
      "三十六",
      "三十七",
      "三十八",
      "三十九",
      "四十",
      "四十一",
      "四十二",
      "四十三",
      "四十四",
      "四十五",
      "四十六",
      "四十七",
      "四十八",
      "四十九",
      "五十",
      "五十一",
      "五十二",
      "五十三",
      "五十四",
      "五十五",
      "五十六",
      "五十七",
      "五十八",
      "五十九"
    ],
    question_tips_content: "为了让「<b>{0}</b>」eLearning学习系统更加完善，诚邀您协助填写一份问卷，您的宝贵意见将能令我们的服务做得更好，谢谢！",
    question_tips_btn1: "点击这里进入填写问卷",
    question_tips_btn2: "未完成全部学习，稍后再填写",
  },
  ...zhCnLocale
};
export default cn;
